import lowerCase from "lodash-es/lowerCase";
import kebabCase from "lodash-es/kebabCase";
import queryString from "query-string";
import { BookUrlType, SocialUrlType } from "types/book.type";
import {
  compact,
  differenceBy,
  isEmpty,
  isObject,
  keyBy,
  map,
} from "lodash-es";
import { AvailableLanguages } from "../types/business.types";

const DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL;
const getNameOfDay = () => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const d = new Date();
  return days[d.getDay()];
};

const generateBookingURL = ({
  uniqueIdentifier,
  type,
  id,
  locale,
}: BookUrlType) => {
  const link = queryString.stringifyUrl({
    url: `${DOMAIN_URL}/widget/${uniqueIdentifier}`,
    query: {
      lng: locale,
      locations: type === "location" ? id : undefined,
      op:
        type === "provider"
          ? `~${id}`
          : type === "service"
          ? `${id}~`
          : undefined,
    },
  });

  return link;
};

const generateSocialShare = ({ type, businessName, url }: SocialUrlType) => {
  let link = "";

  switch (type) {
    case "facebook":
      link += `https://facebook.com/sharer/sharer.php?u=${url}`;
      break;

    case "twitter":
      link += `https://twitter.com/intent/tweet/?text=${businessName}&url=${url}`;

      break;

    default:
      break;
  }

  return link;
};

const formatTime24 = (timeString: string) => {
  const [hourString, minute] = timeString.split(":");
  const hour = +hourString % 24;
  return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};

const truncateString = (str: string, num: number = 13) => {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
};

const isProd = () => process.env.NODE_ENV === "production";

const resolvedPublicPath = (path: string) => {
  return `/b/${path}`;
};

const toSearchEngineFriendlyWords = (input: string) => {
  return encodeURIComponent(kebabCase(lowerCase(input)));
};

const generateSectionLabel = (label: string, limit = 13) => {
  return truncateString(label, limit);
};

export function sortListByAnotherList(
  unsortedList: Array<any>,
  sortedList: Array<any>,
  key = "id"
) {
  if (isEmpty(unsortedList) || isEmpty(sortedList)) {
    return unsortedList;
  }

  const indexedUnsortedList = keyBy(unsortedList, key);

  if (!isObject(sortedList[0])) {
    const diff = differenceBy(
      map(unsortedList, (item) => item && item[key]),
      sortedList
    );
    return compact(
      map([...sortedList, ...diff], (key) => indexedUnsortedList[key])
    );
  } else {
    const diff = differenceBy(unsortedList, sortedList, key);
    return compact(
      map([...sortedList, ...diff], (item) => indexedUnsortedList[item[key]])
    );
  }
}

export {
  getNameOfDay,
  generateBookingURL,
  generateSocialShare,
  formatTime24,
  truncateString,
  resolvedPublicPath,
  isProd,
  toSearchEngineFriendlyWords,
  generateSectionLabel,
};
